import PropTypes from "prop-types";
import React from "react";
import { Col, Container, Row } from "shards-react";
import PageTitle from "../components/page-tittle-component/PageTitle";
import MainFooter from "../components/layout/MainFooter";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import NavbarNav from "../components/layout/NavbarNav";
import AuthService from "../services/auth-service/AuthService";
import { useMountBreadCrumb } from "../hooks/useMountBreadCrumb";

const DefaultLayout = ({ children, noFooter, pageNumber }) => {
    const perfil = AuthService.getDecodedToken().role;
    const { breadCrumb } = useMountBreadCrumb();
    return (
        <Container fluid>
            <Row>
                <MainSidebar pageNumber={pageNumber} />
                <Col className="p-0" sm={12} md={0} lg={0}>
                    <NavbarNav />
                </Col>
                <Col
                    className="main-content p-0"
                    lg={{ size: 10, offset: 2 }}
                    md={{ size: 9, offset: 3 }}
                    sm="12"
                    tag="main"
                >
                    <Container fluid className="main-content-container px-4">
                        {/* Page Header */}
                        <Row noGutters className="page-header py-4">
                            {process.env.REACT_APP_ENV_ALERT ===
                                "Desenvolvimento" && (
                                <PageTitle
                                    sm="4"
                                    title={perfil}
                                    subtitle="Perfil"
                                    className="text-sm-left"
                                />
                            )}
                        </Row>
                        {breadCrumb ? <Row noGutters>{breadCrumb}</Row> : null}

                        <Row>
                            <Col>{children}</Col>
                        </Row>
                    </Container>
                    {!noFooter && <MainFooter />}
                </Col>
            </Row>
        </Container>
    );
};

DefaultLayout.propTypes = {
    /**
     * Whether to display the navbar, or not.
     */
    //   noNavbar: PropTypes.bool,
    /**
     * Whether to display the footer, or not.
     */
    noFooter: PropTypes.bool,
    children: PropTypes.any,
    pageName: PropTypes.string,
    breadCrumb: PropTypes.any,
    pageNumber: PropTypes.string
};

DefaultLayout.defaultProps = {
    noFooter: false
};

export default DefaultLayout;
